/** Display labels for API status values, shared by the employee and manager panels. */

export const WORKDAY_STATUS_LABELS = {
  proposed: 'Oczekuje',
  approved: 'Zatwierdzony',
  rejected: 'Odrzucony',
};

export const SWAP_STATUS_LABELS = {
  pending_target: 'Oczekuje na współpracownika',
  pending_manager: 'Oczekuje na kierownika',
  approved: 'Zatwierdzona',
  rejected: 'Odrzucona',
};
